import { render, staticRenderFns } from "./ChatlynTimeAgo.vue?vue&type=template&id=ace1630a&"
import script from "./ChatlynTimeAgo.vue?vue&type=script&lang=js&"
export * from "./ChatlynTimeAgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports